(function() {
  if (window.__deliveryNoteInitialized) return;
  window.__deliveryNoteInitialized = true;

  function updateDeliveryNoteTime() {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    let delivery_day = 'Morgen';
    let delivery_text = 'Wenn Sie jetzt bestellen';
    const targetTime = new Date();
    targetTime.setHours(12, 30, 0, 0);
    const timeRemaining = targetTime - now;
    const hoursRemaining = Math.floor(timeRemaining / (1000 * 60 * 60));
    const minutesRemaining = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    if (dayOfWeek === 6 || dayOfWeek === 0 || (dayOfWeek === 5 && (hours === 12 && minutes >= 30 || hours > 12))) {
      delivery_day = 'Dienstag';
    } else if (dayOfWeek <= 5 && (hours === 12 && minutes < 30 || hours < 12)) {
      delivery_text = 'Bei Bestellung innerhalb von ' +
        hoursRemaining + ' Stunde(n) und ' + minutesRemaining + ' Minuten';
    } else {
      const date = new Date();
      date.setDate(date.getDate() + 2);
      delivery_day = date.toLocaleDateString('de-DE', { weekday: 'long' });
    }
    const html = '<b>Kostenlose Lieferung: ' + delivery_day + '</b>  - ' + delivery_text + '.';
    // Update every countdown element (product page block + cart drawer).
    // Guarded write: skip when content is unchanged so the MutationObserver
    // below cannot trigger an update loop.
    document.querySelectorAll('[id^="delivery-countdown"]').forEach(function (el) {
      if (el.innerHTML !== html) el.innerHTML = html;
    });
    setTimeout(updateDeliveryNoteTime, 60000);
  }

  document.addEventListener('DOMContentLoaded', updateDeliveryNoteTime);

  // The cart drawer re-renders its section via AJAX (cart-drawer.js
  // renderContents), which recreates #delivery-countdown with empty content.
  // Re-run the update whenever the DOM changes so the countdown reappears
  // immediately after items are added/removed.
  const observer = new MutationObserver(function () {
    updateDeliveryNoteTime();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
